import validate from 'validate.js';
import { isValidIBAN } from 'ibantools';
import i18n from '~/i18n/locale';

validate.validators.iban = function(value, options) {
  if (!isValidIBAN(value)) {
    return options.message || i18n.t('user_backend.js.validations.iban');
  }
};
